const state = {
    message: {
        display: false,
        color: "info",
        text: "Initial test",
        timeout: 2000
    }
};
  
const actions = {
    sendMessage({ commit }, message) {
        message.display = true;
        commit("setMessage", message);
    },
    clearMessage({ commit }) {
        let message = state.message;
        message.display = false;
        commit("setMessage", message);
    }
};
  
const mutations = {
    setMessage: (state, message) => (state.message = message)
};
  
export default {
    state,
    actions,
    mutations
};
  